// extracted by mini-css-extract-plugin
export default {"noMargin":"typography-module___noMargin___b6048c9a","clipOverflow":"typography-module___clipOverflow___d653b1c8"};